import { confirmResetPassword, resetPassword, signOut } from 'aws-amplify/auth';
import mixpanel from 'mixpanel-browser';
import {
  updateMembershipWithAppleIAP,
  updateMembershipWithGooglePlayPurchase,
} from '../operations/user_profile_operations';
import { closeAllGuides } from '../operations/product_guides_operations';
import {
  getMixpanelGeolocationOperation,
  resetTrackingOnSignOut,
} from '../operations/tracking_operations';
import { geoRegionFromCountryCode } from '../services/geo_regions';
import { AppStoreID } from '../API';
import { useNativeAppStoreID } from '../services/app_stores';
import { appSyncGraphQLApi } from '../app/smorgAppSyncGraphQLApi';

export const signOutAction = () => {
  return async (dispatch) => {
    closeAllGuides();
    signOut();
    dispatch(appSyncGraphQLApi.util.resetApiState());
    resetTrackingOnSignOut();
  };
};

export const sendPasswordResetCodeAction = (email) => {
  return async () => {
    return resetPassword({ username: email });
  };
};

export const resetPasswordAction = (email, code, cleartextPassword) => {
  return async () => {
    return confirmResetPassword({
      username: email,
      confirmationCode: code,
      newPassword: cleartextPassword,
    });
  };
};

export const getDefaultOnboardingUserProfileFields = async () => {
  const userProfileFieldsChoices = {};
  try {
    const mixpanelDistinctId = mixpanel.get_distinct_id();
    if (mixpanelDistinctId) {
      const mixpanelGeolocation = await getMixpanelGeolocationOperation(
        mixpanelDistinctId,
      );
      console.log({ mixpanelGeolocation });
      userProfileFieldsChoices.countryCode = mixpanelGeolocation.countryCode;
      if (
        !userProfileFieldsChoices.geoRegion &&
        userProfileFieldsChoices.countryCode
      ) {
        userProfileFieldsChoices.geoRegion = geoRegionFromCountryCode(
          userProfileFieldsChoices.countryCode,
        );
      }
    }
    return userProfileFieldsChoices;
  } catch (e) {
    console.log('While fetching geolocation from Mixpanel');
    console.log(e);
    return {};
  }
};

export const submitDeferredIapPurchasesAction = (currentSpaceMembership) => {
  return async (dispatch, getState) => {
    const { deferredPurchases } = getState().iap;
    const nativeAppStoreID = useNativeAppStoreID();
    // eslint-disable-next-line no-restricted-syntax
    for (const stringifiedPurchase of deferredPurchases) {
      const purchase = JSON.parse(stringifiedPurchase);
      if (nativeAppStoreID === AppStoreID.GOOGLE_PLAY_STORE) {
        // eslint-disable-next-line no-await-in-loop
        await updateMembershipWithGooglePlayPurchase(
          purchase,
          currentSpaceMembership,
          dispatch,
        );
      } else {
        // eslint-disable-next-line no-await-in-loop
        await updateMembershipWithAppleIAP(
          purchase,
          currentSpaceMembership,
          dispatch,
        );
      }
    }
  };
};
